import { css } from '@fable/theme'
import { StatsThemeSelector } from './StatsThemeSelector'
import { StatsPrivacySelector } from './StatsPrivacySelector'
import { FlexBox } from '@fable/components'
import { OverflowMenu } from '../shared'
import { StatsMenuActions } from './StatsMenuActions'
import { useState } from 'react'
import { StatsMenuActionItem } from '../../types'
import { sendToNative } from 'app/webview/utils'
import { useStatsPermission } from '../../lib/hooks'
import { useStats } from '../../lib/ctx/stats'
import { StatsItemOptInSelector } from './StatsItemOptInSelector'
import { useReaderSummary } from '../../lib/ctx/reader_summary'

export const StatsMenu = () => {
  const [isDesktop, year, isV2] = useStats((s) => [s.isDesktop, s.year, s.isV2])
  const isSummaryV2 = useReaderSummary((s) => s.isSummaryV2)
  const { isInspecting, isAndroid } = useStatsPermission()
  const [debug, setDebug] = useStats((s) => [s.debug, s.setDebug])
  const [open, setOpen] = useState(false)

  const menuActions: StatsMenuActionItem[] = [
    {
      id: 'refresh',
      text: 'Refresh my Stats',
      icon: 'refresh',
      type: 'button',
      onClick: () => window.location.reload(),
    },
    {
      id: 'edit-finished-list',
      text: 'Edit Finished List',
      icon: 'star',
      type: 'deep_link',
      // @TODO: feature not ready to launch
      link: isAndroid ? '' : 'https://fable.co/app/book-list/finished',
    },
    {
      id: 'edit-past-streaks',
      text: 'Edit Past Streaks',
      icon: 'history',
      type: 'deep_link',
      // @TODO: feature not ready to launch
      link: isAndroid ? '' : 'https://fable.co/app/streak_management',
    },
    {
      id: 'edit-reading-goal',
      text: `Update ${year} Reading Goal`,
      icon: 'trophy-outline',
      type: 'deep_link',
      // @TODO: pending deep link
      link: '',
    },
  ]

  if (isInspecting) {
    menuActions.push({
      id: 'debug',
      text: `${debug ? 'Hide' : 'Show'} inspector`,
      icon: debug ? 'eye-off' : 'eye',
      type: 'button',
      onClick: () => setDebug(!debug),
    })
  }

  const close = () => setOpen(false)

  const handleActionClick = (action: StatsMenuActionItem) => {
    setOpen(false)

    if (action.type === 'deep_link') {
      sendToNative({
        id: action.id,
        payload: {
          type: 'deep_link',
          body: {
            url: action.link,
            close: true,
          },
        },
      })
    }
  }

  return (
    <div>
      <OverflowMenu
        dataTestId="stats-menu-button"
        open={open}
        setOpen={setOpen}
        wrapperStyles={css`
          top: 48px;
        `}
        icon="edit-alt"
        size="M"
        containerStyles={css`
          padding-bottom: 8px;
          max-height: 445px;
        `}
      >
        <FlexBox
          className={css`
            width: 100%;
            gap: 10px;
          `}
          flexDirection="column"
        >
          <StatsThemeSelector onSelect={close} />
          <StatsPrivacySelector />
          {isV2 && isSummaryV2 ? (
            <StatsItemOptInSelector
              selector="reader-summary"
              onSelect={close}
            />
          ) : null}
          {isV2 ? (
            <StatsItemOptInSelector selector="goal" onSelect={close} />
          ) : null}
          {isDesktop ? null : (
            <StatsMenuActions
              actions={menuActions}
              onSelect={handleActionClick}
            />
          )}
        </FlexBox>
      </OverflowMenu>
    </div>
  )
}
